import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useContextStore } from "@/store/context";
import { usePanachagesStore } from "@/store/panachages";

export const usePageArticle = () => {
  const shopId = ref(null);
  const panachagesStore = usePanachagesStore();
  const contextStore = useContextStore();

  const { status } = storeToRefs(panachagesStore);
  const { layout, requestTime } = storeToRefs(contextStore);

  const { resetPanachages: reset } = panachagesStore;

  const component = computed(() => {
    return loadPageWithLoader(lazyComponents[`/components/pages/product-sheet/${layout.value}.vue`]);
  })

  const created = () => {
    if (status.value) {
      reset();
    }
  }

  const head = (product) => {
    if (!product) {
      return {};
    }
    return {
      title: product.attributes.designation,
      meta: [
        {
          hid: "description",
          name: "description",
          content: product.attributes.description
        }
      ],
      link: [{ rel: "canonical", href: product.attributes.slug }]
    };
  }

  return {
    shopId,
    status,
    layout,
    requestTime,
    component,
    created,
    head
  }
}